module.exports = __webpack_public_path__ + "img/11.3e2f5013.jpg";